import { useLocation, Link } from "react-router-dom";
import { siteConfig } from "@/mocks/data";
import PageMeta from "@/components/base/PageMeta";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-6">
      <PageMeta
        title="找不到頁面｜樂律 Lelyric"
        description="此頁面不存在或連結無效，請返回樂律首頁或前往書籍資料庫查詢。"
        noindex
      />
      <div className="text-center max-w-md">
        <div className="font-heading text-[7rem] md:text-[8.5rem] font-bold text-foreground-100 select-none mb-2 leading-none tracking-tight">
          404
        </div>
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
          找不到頁面
        </h1>
        <p className="text-base text-foreground-500 leading-relaxed mb-2">
          找不到路徑：<code className="text-[13px] bg-background-100 px-1.5 py-0.5 rounded tracking-wide">{location.pathname}</code>
        </p>
        <p className="text-base text-foreground-400 leading-relaxed mb-9">
          此頁面可能已被移除、連結無效，或尚未建立。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap px-6 py-2.5 rounded-full text-[14px] font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer tracking-wide"
          >
            返回首頁
            <i className="ri-arrow-right-line ml-1.5 text-[13px]"></i>
          </Link>
          <a
            href={siteConfig.catalogUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap px-6 py-2.5 rounded-full text-[14px] font-medium border border-foreground-200 text-foreground-700 hover:border-foreground-400 hover:bg-background-100 transition-all cursor-pointer"
          >
            前往書籍資料庫
            <i className="ri-external-link-line ml-1.5 text-[13px]"></i>
          </a>
        </div>
      </div>
    </div>
  );
}